"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const settingInitialState = {
    isChangePasswordVisible: false,
    isLoading: false,
    isLoadingCount: 0,
    confirmationDialog: {},
    timePicker: {},
    isLoaderCount: 0,
};
const settingReducer = (state = settingInitialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};
exports.default = settingReducer;
//# sourceMappingURL=settingReducer.js.map